{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              68.13692186188689,
              23.817894635358073
            ],
            [
              68.88635701427268,
              21.73000667060633
            ],
            [
              70.94487196624414,
              19.854920337075967
            ],
            [
              77.155692018379,
              7.42339506411227
            ],
            [
              78.9344686632474,
              8.165826768007975
            ],
            [
              80.93061931080894,
              12.424338940273529
            ],
            [
              81.25973479782789,
              15.124636408176173
            ],
            [
              89.1623280061799,
              21.43864067048517
            ],
            [
              88.71609356229328,
              24.141199992630277
            ],
            [
              87.54454708705015,
              26.314479919028855
            ],
            [
              80.12978830112343,
              28.85006173634413
            ],
            [
              80.84807176603852,
              30.27720998654975
            ],
            [
              76.58432340636705,
              33.063357234649715
            ],
            [
              74.64813658231736,
              31.930206498848023
            ],
            [
              73.0108585110282,
              28.912956094960208
            ],
            [
              70.53780995418094,
              28.123054150236783
            ],
            [
              69.62389563044505,
              26.952474773059677
            ],
            [
              71.10262234599463,
              24.483720012686575
            ],
            [
              68.13692186188689,
              23.817894635358073
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}